import { render, staticRenderFns } from "./HistoryChangeTable.vue?vue&type=template&id=e958031c"
import script from "./HistoryChangeTable.vue?vue&type=script&lang=js"
export * from "./HistoryChangeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports